import { types } from 'mobx-state-tree';
import { matchRoutes } from 'react-router-config';

const SceneChangerStore = types
  .model('SceneChanger', {
    shouldHandleColors: types.optional(types.boolean, false),
  })
  .actions(self => {
    let sceneChanger;

    return {
      setSceneChangerInstance(instance) {
        sceneChanger = instance;
      },

      init() {
        self.shouldHandleColors = false;
      },

      getRoute(routes, pathname) {
        self.shouldHandleColors = false;

        const matchedRoutes = matchRoutes(routes, pathname);
        return matchedRoutes[matchedRoutes.length - 1].route;
      },

      setShouldHandleColors() {
        self.shouldHandleColors = true;
      },

      handleAnimationEnd(to, fromAnimation) {
        setTimeout(() => {
          sceneChanger.handleAnimationEnd(fromAnimation);
          history.pushState({}, 'next scene', to);
        }, 100);
      },

      onLinkClick(to, runAnimation) {
        sceneChanger.handleLinkClick(to);
        runAnimation().then(fromAnimation => self.handleAnimationEnd(to, fromAnimation));
      },
    };
  });

export default SceneChangerStore;



// WEBPACK FOOTER //
// ./src/stores/SceneChangerStore.js